import {LoadingView} from "./loading.view";
export default LoadingView;
